/**
 * éä¸­è¡ä¸ä¸æ
 */
export class SelectedRowContext {
    /**
     * å½åéä¸­è¡Index
     */
    currentRowIndex: number;

    /**
     * ä¸ä¸ä¸ªéä¸­è¡Index
     */
    lastRowIndex: number;
}
